import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { RateAgreementStatus } from "model/schema/globalTypes";

// Colors follow the rate agreement lifecycle design spec, not the generic status palette.
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5)
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    flexShrink: 0
  },
  label: {
    fontFamily: "Segoe UI",
    fontWeight: 400,
    fontSize: "12px"
  },
  dotDraft: { backgroundColor: "#485255" },
  labelDraft: { color: "#485255" },
  dotReleased: { backgroundColor: "#2A932A" },
  labelReleased: { color: "#1C721C" },
  dotArchived: { backgroundColor: "#8C8C8C" },
  labelArchived: { color: "#686868" }
}));

const STATUS_LABELS: Record<RateAgreementStatus, string> = {
  [RateAgreementStatus.Draft]: "Draft",
  [RateAgreementStatus.Released]: "Released",
  [RateAgreementStatus.Archived]: "Archived"
};

interface RateAgreementStatusIndicatorProps {
  status: RateAgreementStatus;
  "data-testid"?: string;
}

export default function RateAgreementStatusIndicator({
  status,
  "data-testid": testId
}: RateAgreementStatusIndicatorProps) {
  const classes = useStyles();

  return (
    <span className={classes.root} data-testid={testId}>
      <span className={clsx(classes.dot, classes[`dot${status}`])} />
      <span className={clsx(classes.label, classes[`label${status}`])}>
        {STATUS_LABELS[status]}
      </span>
    </span>
  );
}
